import { render, staticRenderFns } from "./couponGive.vue?vue&type=template&id=6954d19e&scoped=true"
import script from "./couponGive.vue?vue&type=script&lang=js"
export * from "./couponGive.vue?vue&type=script&lang=js"
import style0 from "./couponGive.vue?vue&type=style&index=0&id=6954d19e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6954d19e",
  null
  
)

export default component.exports